import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse} from 'query-string';
import EventsComponent from '../components/Events';
import {fetchEvents, appendEventsNextPageAction} from "../actions/events";
import {setFulltextSearch} from "../actions/filters";
import {selectBezirk} from "../actions/bezirke"

class Events extends Component
{
    componentDidMount() {
        let search = parse(window.location.search)
        if (search.tid) {
            console.log(window.location);
            window.history.pushState(search, '', window.location.origin+window.location.pathname)
            this.props.dispatch(setFulltextSearch(search.tid));
            this.props.dispatch(selectBezirk(null));
        }
        if (search.suche) {
            console.log(window.location);
            window.history.pushState(search, '', window.location.origin+window.location.pathname)
            this.props.dispatch(setFulltextSearch(search.suche));
            this.props.dispatch(selectBezirk(null));
        }
        this.props.dispatch(fetchEvents());

    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedKreis !== this.props.selectedKreis
        || prevProps.selectedBezirk !== this.props.selectedBezirk
        || prevProps.selectedFachgebiet !== this.props.selectedFachgebiet
        || prevProps.fulltext !== this.props.fulltext
        || prevProps.hdbl !== this.props.hdbl
        || prevProps.online !== this.props.online
        || prevProps.offline !== this.props.offline
        || prevProps.date !== this.props.date) {
            this.props.dispatch(fetchEvents());
        }
    }

    render() {
        return <div>
                <EventsComponent events={this.props.events} fulltext={this.props.fulltext} selectedDate={this.props.date} appendEventsNextPage={this.appendEventsNextPage.bind(this)} eventsAdding={this.props.eventsAdding}/>
            </div>
    }

    appendEventsNextPage(page) {
        this.props.dispatch(appendEventsNextPageAction(page));
    }
}

const mapStateToProps = store=>{
    return {
        events: store.events.list,
        eventsAdding: store.events.isAdding,
        selectedKreis: store.kreise.selected,
        selectedBezirk: store.bezirke.selected,
        selectedFachgebiet: store.fachgebiete.selected,
        fulltext: store.filters.phrase,
        hdbl: store.filters.hdbl,
        online: store.filters.online,
        offline: store.filters.offline,
        date: store.filters.date,
    }
}

export default connect(mapStateToProps)(Events)



// WEBPACK FOOTER //
// ./src/containers/Events.js